import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CrudTableViewConfig } from '../../utils/list-grid';
import { ButtonComponentConfig } from '../../utils/button';
import { AlertConfig } from '../../utils/alert';
import { EditFormComponentConfig } from '../../utils/form-card';

@Component({
  selector: 'rappider-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss'],
})
export class RappiderFileExplorerComponent {
  @Input() activeEntityData = [];
  @Input() listGridConfig: CrudTableViewConfig;
  @Input() editFormConfig: EditFormComponentConfig;
  @Input() selectedItem: any;
  @Input() loading: boolean;
  @Input() editFormVisible: boolean;
  @Input() submitButtonLoading = false;
  @Input() buttonConfig: ButtonComponentConfig;
  @Input() alertConfig: AlertConfig;
  @Input() modalConfig = {
    title: 'Please Check Information',
    okText: 'Submit',
    closeIconVisibility: 'true',
    width: '60%',
    footer: undefined,
    cancelText: undefined,
    okDisabled: undefined,
    cancelDisabled: undefined,
    okLoading: undefined,
    okDanger: undefined,
    mask: undefined,
    maskClosable: undefined,
    className: undefined,
    bodyStyle: undefined,
    fullScreen: undefined,
  };
  @Input() modalVisibility = false;
  @Input() isModalActive = true;
  // It stores the state of the nested folders.
  @Input() folderOrder;

  @Output() searchTextChange = new EventEmitter();
  @Output() rowActionClick = new EventEmitter();
  @Output() overflowlistItemClick = new EventEmitter();
  @Output() buttonConfirm = new EventEmitter();
  @Output() buttonPopconfirmCancel = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  @Output() selectionChange = new EventEmitter();
  @Output() formValueChange = new EventEmitter();

  selectedData;

  onSearchTextChange(text) {
    this.searchTextChange.emit(text);
  }

  onRowActionClick(row) {
    this.rowActionClick.emit(row);
  }

  onOverflowlistItemClick(item) {
    this.overflowlistItemClick.emit(item);
  }

  onConfirm() {
    this.buttonConfirm.emit();
  }

  onPopconfirmCancel() {
    this.buttonPopconfirmCancel.emit();
  }

  onClick() {
    if (!this.isModalActive) {
      this.buttonClick.emit();
    } else if (this.isModalActive && this.selectedData?.length) {
      this.modalVisibility = true;
    }
  }

  onSelectionChange(selectedData) {
    this.selectedData = selectedData;
    this.selectionChange.emit(selectedData);
  }

  onFormValueChange(formValue) {
    this.formValueChange.emit(formValue);
  }

  onModalSelectClick() {
    this.buttonClick.emit();
  }

  onModalVisibleChange(visible) { }
  onModalAfterModalOpen() { }
  onModalCancelClick() {
    this.modalVisibility = false;
  }
}
